<template>
  <div id="gallary" class="grid">
    <div class="grid-title">
      <h4>{{ $t("IMAGES") }}</h4>
    </div>
    <div class="grid-body p-3 pb-0">
        <upload-controller
          :uploadedFiles="uploadedFiles"
          @reload="initialize"
        />
        <image-gallary
          :totalFiles.sync="total"
          :uploadedFiles.sync="uploadedFiles"
        />
        <!-- <paging :paging.sync="paging" @changePage="getImagesResource">
          <span slot="totalItems" v-if="paging">Tổng: {{paging.total}} ảnh</span>
        </paging>-->
        <div class="mr-3 pb-3 d-flex align-center" style="max-width: 350px">
          <label class="text-nowrap mr-2">{{
            $t("CHANNEL_APPLY")
          }}</label>
          <v-autocomplete dense outlined item-text="text" item-value="value" :items="listOtaConnectGlobal"
            v-model="selectedOTAGlobal" chips multiple style="width: 270px;" disabled>
            <template v-slot:selection="{ item, index }">
              <v-chip color="primary" v-bind="item.attrs" :input-value="item.selected" >
                <span>{{ item.text }}</span>
              </v-chip>
            </template>
          </v-autocomplete>
        </div>
      </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import UploadController from "@/components/HotelSetting/GalleryManager/UploadController.vue";
import ImageGallary from "@/components/HotelSetting/GalleryManager/ImageGallery.vue";
// import Paging from "@/components/Utils/Paging.vue";
import { systemService } from "@/_services/system-data.service.js";
// import { LIMIT_AND_OFFSET } from "@/_helpers/config.js";

export default {
  components: {
    "upload-controller": UploadController,
    "image-gallary": ImageGallary,
    // paging: Paging
  },
  data() {
    return {
      isPaging: false,
      total: 0,
      uploadedFiles: [],
      paging: {
        total: 0,
        limit: 0,
        offset: 0
      },
    };
  },
  created() {
    this.initialize();
  },
  watch: {},
  computed: {},
  methods: {
    async initialize() {
      let params = {
        limit: 20,
        offset: 0
      };
      await systemService.getImagesResource(params).then(res => {
        this.total = res.total;
        this.uploadedFiles = res.data;
        this.paging = {
          total: res.total,
          limit: params.limit,
          offset: params.offset
        };
      });

      for (let i = params.limit; i < this.total; i += params.limit) {
        let param = {
          limit: 20,
          offset: i
        };
        await systemService.getImagesResource(param).then(res => {
          this.uploadedFiles.push(...res.data);
        });
      }
    }
  },
  destroyed() {
    this.total = 1;
  },
};
</script>
